import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import styles from './styles';

export default withStyles(styles)(Checkbox);
